function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import intlShape from 'shapes/intlShape';
import messages from '../../messages';
import Error from './Error';
var _React_PureComponent;
class NotFound extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { intl, isAuthenticated } = this.props;
        return /*#__PURE__*/ _jsx(Error, {
            code: 404,
            codeLabel: intl.formatMessage(messages.errorPage.errorCode),
            title: intl.formatMessage(messages.errorPage.notFound.title),
            info: intl.formatMessage(messages.errorPage.notFound.info),
            buttonLabel: intl.formatMessage(messages.errorPage.goToHomePage),
            isAuthenticated: isAuthenticated
        });
    }
}
_define_property(NotFound, "propTypes", {
    isAuthenticated: PropTypes.bool,
    intl: intlShape
});
export default injectIntl(NotFound);
